import { useAuthStore } from '@ms/stores/auth'

document.addEventListener('visibilitychange', function () {
  // 用户离开了当前页面
  if (document.visibilityState === 'hidden') {
    const now = Date.now()
    sessionStorage.setItem('v_time', now)
  } else if (document.visibilityState === 'visible') {
    // 用户打开或回到页面
    if (!useAuthStore().loginStatus) {
      useAuthStore().autoCheck()
    }
    const lastTime = sessionStorage.getItem('v_time')
    if (lastTime) {
      const diffTime = Date.now() - lastTime
      if (diffTime > 3 * 3600000) {
        // 用户离开超过3小时，刷新页面
        location.reload()
      }
    }
  }
})
